// extracted by mini-css-extract-plugin
export default {"card":"LandingCard_card__3sWlH","example_c":"LandingCard_example_c__9YhyQ"};